export enum ConversationMessageDeveloperMessageEnum {
  NoFunds = `the message could not be sent. you do not have enough funds on your conversation prepaid balance 
  to engage in any paid conversation.`,
}
